// The application. Each option is [text, score, hardStopReason?].
// Shopify cannot grade privately, so the scores ship in this file. Anyone who
// reads the source can see them. That is accepted: it is a filter, not a lock.
// A question with cat: null is asked for Ryan's information and is not scored.

const PASS_MARK = 58; // two-thirds of the 87 available

const REASONS = {
  time: "Right now you do not have the hours. A store needs steady time every week, and it shows quickly when it does not get it.",
  money: "The money side is not ready yet. You need a small amount you can afford to lose, and the patience to wait before it pays you back.",
  expect: "What you are expecting is not what this is. Stores are slow to start, and most first attempts fail.",
  drive: "This course leaves you to do the work on your own. Your answers suggest you would want more hand-holding than it gives.",
  ready: "A few basics are missing: the device, the connection, or the comfort with computers you need to build a store yourself.",
};

const QUESTIONS = [
  { cat: "time", q: "How many hours a week can you honestly give this for the next three months?", a: [
    ["More than 10", 3], ["5 to 10", 2], ["2 to 5", 1], ["Less than 2", 0]] },
  { cat: "time", q: "Where will those hours come from?", a: [
    ["I have already picked the days and times", 3], ["Evenings and weekends, roughly", 2], ["I will find time when I can", 1], ["I am not sure yet", 0]] },
  { cat: "time", q: "How soon do you want to start building?", a: [
    ["This week", 3], ["This month", 2], ["In the next few months", 1], ["Someday", 0]] },

  { cat: "money", q: "A store costs money to start: stock, a domain, a Shopify plan, some ads. Where would yours come from?", a: [
    ["Savings I can afford to lose", 3], ["Small amounts from my monthly income", 2], ["I have none yet, so I would save first", 1],
    ["I would borrow it, or use money meant for rent and bills", 0, "You said the money to start would be borrowed, or taken from rent and bills. Please do not start a store with money you cannot afford to lose. Come back when you have a little set aside."]] },
  { cat: "money", q: "You spend R2,000 on ads and get zero sales. What do you do?", a: [
    ["Work out what went wrong, change one thing, and test again", 3], ["Pause, learn more, then try again", 2], ["Switch to a different product", 1], ["Stop. It does not work", 0]] },
  { cat: "money", q: "How long could you keep going before the store pays you anything?", a: [
    ["Six months or more", 3], ["Three to six months", 2], ["One to three months", 1], ["I need it to pay me this month", 0]] },

  { cat: "expect", q: "What do you expect 30 days after finishing the course?", a: [
    ["A live store and my first few tests running", 3], ["My first sale", 2], ["A store that runs itself", 0], ["Enough to replace my salary", 0]] },
  { cat: "expect", q: "Which is closest to what you believe about online stores?", a: [
    ["It is a real business. Most attempts fail and some work", 3], ["It is hard at first and gets easier", 2], ["It is mostly about finding one winning product", 1], ["It is passive income once it is set up", 0]] },
  { cat: "drive", q: "This course shows you the basics and a little more. It is not coaching, and nobody builds the store for you. How does that sit with you?", a: [
    ["That is exactly what I want", 3], ["Fine. I will work the rest out myself", 3], ["I would want someone checking my work regularly", 1],
    ["I want someone to do it with me, or for me", 0, "You are looking for someone to build it with you, or for you. This course does not do that."]] },
  { cat: "expect", q: "You do everything in the course and your first store still fails. Then what?", a: [
    ["I take what I learned and build the next one", 3], ["I would be disappointed, but I would try again", 2], ["I probably would not try again", 1],
    ["I would feel the course had lied to me", 0, "No course can promise sales, and this one does not. If a failed first store would feel like a broken promise, this is not the right place to start."]] },
  { cat: "expect", q: "Ryan had quite a few stores fail before three worked. What does that tell you?", a: [
    ["That failing is part of it, and I should be ready for mine to fail too", 3], ["That it takes a few tries to learn", 3], ["That he should have planned better", 1], ["That I would rather skip that part", 0]] },

  { cat: "drive", q: "Think of the last thing you taught yourself. How did it go?", a: [
    ["I stuck with it until I could do it", 3], ["I got to okay, then stopped", 2], ["I started and dropped it", 1], ["I cannot think of one", 0]] },
  { cat: "drive", q: "You are stuck on something technical. What is your first move?", a: [
    ["Search and try things until it works", 3], ["Search for a while, then ask someone", 2], ["Ask someone straight away", 1], ["Leave it", 0]] },
  { cat: "drive", q: "Someone tells you your work is not good enough yet. You:", a: [
    ["Ask for specifics and fix it", 3], ["Feel it, then use it", 2], ["Explain why they are wrong", 1], ["Lose interest", 0]] },
  { cat: "drive", q: "How many online courses have you paid for and not finished?", a: [
    ["None, or I finished every one", 3], ["One", 2], ["A few", 1], ["Most of them", 0]] },
  { cat: null, q: "What is most likely to stop you?", a: [
    ["Time", 0], ["Money", 0], ["Fear that it will not work", 0], ["Not knowing what to sell", 0]] },
  { cat: "drive", q: "Have you ever sold anything, online or in person?", a: [
    ["Yes, I have run a business or a side hustle", 3], ["Yes, on a marketplace or to people I know", 2], ["Only as part of a job", 2], ["Never", 1]] },
  { cat: "drive", q: "When nobody is checking, do you do the work?", a: [
    ["Always", 3], ["Mostly", 2], ["Only when there is a deadline", 1], ["Rarely", 0]] },

  { cat: "ready", q: "Are you 18 or older?", a: [
    ["Yes", 3], ["No", 0, "You need to be 18 to open a store and a payment account in your own name. Come back then."]] },
  { cat: "ready", q: "What will you build your store on?", a: [
    ["My own laptop or desktop", 3], ["A shared or borrowed computer", 2], ["A phone or tablet only", 1], ["I do not have a device yet", 0]] },
  { cat: "ready", q: "How is your internet?", a: [
    ["Reliable, every day", 3], ["Fine most days", 2], ["Patchy", 1], ["I do not have regular access", 0]] },
  { cat: "ready", q: "How are you with computers?", a: [
    ["I can work out most new apps on my own", 3], ["I am fine if I have steps to follow", 2], ["I need someone to show me", 1], ["I struggle", 0]] },
  { cat: "ready", q: "Do you have a product in mind?", a: [
    ["Yes, and I know where I would get it", 3], ["Yes, but not where to get it", 2], ["A few loose ideas", 1], ["No. I am hoping the course tells me", 1]] },
  { cat: "ready", q: "Have you tried an online store before?", a: [
    ["Yes, and it is still running", 3], ["Yes. It failed, and I know why", 3], ["Yes. It failed, and I am not sure why", 2], ["No, this would be my first", 2]] },

  { cat: "expect", q: "Why do you want a store?", a: [
    ["To build something that is mine", 3], ["For extra income next to my job", 3], ["To get out of my job as fast as possible", 1], ["I saw someone make it look easy", 0]] },
  { cat: "expect", q: "What do you want to walk away with?", a: [
    ["The knowledge and confidence to build it myself", 3], ["Steps I can copy exactly", 1], ["A finished store", 0], ["A guaranteed winning product", 0]] },
  { cat: "drive", q: "How will you take the course?", a: [
    ["Build my store as I go, lesson by lesson", 3], ["Watch it all first, then build", 2], ["Watch it first and see how I feel", 1], ["Mostly I just want to watch", 0]] },
  { cat: "drive", q: "A customer emails, angry that their order is late. You:", a: [
    ["Reply the same day, own it, and fix it", 3], ["Reply once I have an answer", 2], ["Refund them so it goes away", 1], ["Leave it. It will sort itself out", 0]] },
  { cat: "expect", q: "A year from now, what would make this worth it?", a: [
    ["A store making steady sales", 3], ["Knowing how to build one, even if my first failed", 3], ["Having quit my job", 1], ["Being rich", 0]] },
  { cat: "drive", q: "Last one. Honestly: are you going to do this?", a: [
    ["Yes. Starting now", 3], ["Yes, once I have sorted one or two things", 2], ["I want to see the course first", 1], ["I am just curious", 0]] },
];

function grade(answers) {
  let score = 0;
  const hard = [];
  const byCat = {};
  QUESTIONS.forEach(({ cat, a }, i) => {
    if (!cat) return;
    const pick = a[answers[i]];
    score += pick[1];
    if (pick[2]) hard.push(pick[2]);
    byCat[cat] ??= { got: 0, max: 0 };
    byCat[cat].got += pick[1];
    byCat[cat].max += Math.max(...a.map((o) => o[1]));
  });

  const passed = hard.length === 0 && score >= PASS_MARK;
  let reasons = [];
  if (!passed) {
    const weak = Object.entries(byCat)
      .map(([cat, { got, max }]) => [cat, got / max])
      .filter(([, share]) => share < 2 / 3)
      .sort((x, y) => x[1] - y[1])
      .slice(0, 2)
      .map(([cat]) => REASONS[cat]);
    reasons = [...hard, ...weak].slice(0, 3);
  }
  return { score, passed, reasons };
}

const sheet = document.getElementById("sheet");
const stage = document.getElementById("stage");
const pass = document.getElementById("pass");
const form = document.getElementById("fs-join");
const tags = document.getElementById("fs-tags");
const email = document.getElementById("fs-email");
const msg = document.getElementById("fs-msg");
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const LETTERS = "ABCD";
const TAGS_KEY = "fs-tags";
let answers = [];
let at = 0;

const el = (tag, props = {}, ...kids) => {
  const node = Object.assign(document.createElement(tag), props);
  node.append(...kids);
  return node;
};

function show(...nodes) {
  pass.hidden = true;
  stage.hidden = false;
  stage.replaceChildren(...nodes);
  sheet.scrollTop = 0;
}

function openSheet() {
  sheet.classList.add("open");
  document.body.classList.add("locked");
}

function close() {
  sheet.classList.remove("open");
  document.body.classList.remove("locked");
}

function start() {
  openSheet();
  if (answers.length === QUESTIONS.length) return finish();
  ask();
}

function ask() {
  const { q, a } = QUESTIONS[at];
  const opts = el("div", { className: "opts" });
  a.forEach(([text], i) => {
    const button = el("button", { type: "button" }, el("b", { textContent: LETTERS[i] }), el("span", { textContent: text }));
    if (answers[at] === i) button.className = "on";
    button.onclick = () => {
      answers[at] = i;
      [...opts.children].forEach((b) => b.classList.toggle("on", b === button));
      setTimeout(() => (at + 1 < QUESTIONS.length ? (at++, ask()) : finish()), 160);
    };
    opts.append(button);
  });

  const fill = el("i");
  fill.style.width = (at / QUESTIONS.length) * 100 + "%";
  const nodes = [
    el("p", { className: "count" }, String(at + 1).padStart(2, "0"), el("small", { textContent: "of " + QUESTIONS.length })),
    el("div", { className: "track" }, fill),
    el("p", { className: "ask", textContent: q }),
    opts,
  ];
  if (at > 0) {
    nodes.push(el("p", { className: "bar", style: "margin-top:22px" },
      el("button", { type: "button", textContent: "← Back", onclick: () => { at--; ask(); } })));
  }
  show(...nodes);
}

function finish() {
  const result = grade(answers);
  if (!result.passed) return declined(result.reasons);

  // Shopify stores these as tags on the customer, so the answers travel with the email.
  tags.value = ["from-scratch", "fs-passed", "fs-score-" + result.score, "fs-answers-" + answers.join("")].join(", ");
  try { sessionStorage.setItem(TAGS_KEY, tags.value); } catch {}
  showPass();
}

function showPass() {
  stage.hidden = true;
  pass.hidden = false;
  sheet.scrollTop = 0;
  email.focus();
}

function declined(reasons) {
  const list = el("ul");
  reasons.forEach((text) => list.append(el("li", { textContent: text })));
  const again = el("button", { className: "btn", type: "button", textContent: "Answer again" });
  again.onclick = () => { answers = []; at = 0; ask(); };
  show(el("div", { className: "verdict" },
    el("h2", { textContent: "Not yet." }),
    el("p", { textContent: "Going on your answers, this course would not be money well spent for you right now. Here is why:" }),
    list,
    el("p", { textContent: "That is not a judgement of you. It is about timing. Nothing you answered has been saved, and you are welcome to apply again when things have changed." }),
    el("p", {}, again)
  ));
}

function done() {
  try { sessionStorage.removeItem(TAGS_KEY); } catch {}
  show(el("div", { className: "verdict" },
    el("h2", { textContent: "Done." }),
    el("span", { className: "hand", textContent: "see you on the other side." }),
    el("p", { textContent: "You are on the list. You will get one email, the day From Scratch opens." }),
    el("p", {}, el("button", { className: "btn", type: "button", textContent: "Close", onclick: close }))
  ));
}

form.addEventListener("submit", (event) => {
  if (!EMAIL.test(email.value.trim())) {
    event.preventDefault();
    msg.textContent = "That email address does not look right. Please check it.";
    msg.className = "msg bad";
    email.focus();
  }
});

document.querySelectorAll("[data-apply]").forEach((node) =>
  node.addEventListener("click", (event) => { event.preventDefault(); start(); }));
document.getElementById("close").onclick = close;
document.addEventListener("keydown", (event) => { if (event.key === "Escape") close(); });

// Shopify reloads the page after the form posts. Pick up where the visitor was.
if (document.getElementById("fs-posted")) {
  openSheet();
  done();
} else if (document.getElementById("fs-errors")) {
  try { tags.value = sessionStorage.getItem(TAGS_KEY) || tags.value; } catch {}
  openSheet();
  showPass();
}
